import { memo as Memo } from 'react'

//* Components
import Container from 'components/common/Container'
import EventItem from './EventItem'

//* Style
import EventsSectionStyle from './style'

const EventsSection = Memo(({ className, items }) => {
	return (
		<EventsSectionStyle className={`${className || ''}`}>
			<Container className={`events-section`}>
				{items.map((item) => (
					<EventItem
						{...item}
						key={item.id}
					/>
				))}
			</Container>
		</EventsSectionStyle>
	)
})

export default EventsSection
